import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  buildWondatwinProductJsonLd,
  WONDATWIN_DESCRIPTION,
  WONDATWIN_ORIGIN,
  WONDATWIN_TITLE,
} from "@/common/wondatwin";
import { CliFaq } from "@/landing/components/CliFaq";
import { HeroVideo } from "@/landing/components/HeroVideo";
import { LandingPrefooter } from "@/landing/components/LandingPrefooter";
import { LINKEDIN_FAQ_ITEMS } from "@/landing/components/linkedin-faq-data";
import { Wab2CliPricing } from "@/landing/components/Wab2CliPricing";
import { Wab2Hero } from "@/landing/components/Wab2Hero";
import { Wab2HowItWorks } from "@/landing/components/Wab2HowItWorks";
import { Wab2UseCases } from "@/landing/components/Wab2UseCases";
import { WhyWonda } from "@/landing/components/WhyWonda";
import wabCss from "@/landing/styles/wab.css?url";

// The /linkedin landing is retired on wonda.sh (server/middleware/retired-pages.ts
// 301s it to /). Its page stays: the standalone Wonda Twin host serves it at its
// root through _landing.index.tsx, with wondatwinLandingHead() below.
export function wondatwinLandingHead() {
  return {
    meta: [
      { title: WONDATWIN_TITLE },
      { name: "description", content: WONDATWIN_DESCRIPTION },
      { property: "og:title", content: WONDATWIN_TITLE },
      { property: "og:description", content: WONDATWIN_DESCRIPTION },
      { property: "og:url", content: WONDATWIN_ORIGIN },
    ],
    links: [
      { rel: "canonical", href: `${WONDATWIN_ORIGIN}/` },
      { rel: "stylesheet", href: wabCss },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Geist:wght@300..700&display=swap",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(buildWondatwinProductJsonLd()),
      },
    ],
  };
}

export const Route = createFileRoute("/_landing/linkedin")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});

export function LinkedinLandingPage({
  isStandalone = false,
}: {
  isStandalone?: boolean;
} = {}) {
  return (
    <>
      <Wab2Hero />
      <HeroVideo />
      <Wab2HowItWorks />
      <WhyWonda />
      <Wab2UseCases />
      <Wab2CliPricing isStandalone={isStandalone} />
      <CliFaq items={LINKEDIN_FAQ_ITEMS} />
      <LandingPrefooter isStandalone={isStandalone} />
    </>
  );
}
